module.exports = __webpack_public_path__ + "img/more_icon.2d079656.svg";